import React from 'react';
import { useIntl } from 'react-intl';

import { Button, FieldRow, FormFooter, Title } from '@xsolla/ui-core';
import { SuccessColorful } from '@xsolla/ui-icons';
import { ModalAlert } from '@xsolla/ui-modal';

type Props = {
  onClose: () => void;
};

const SuccessModal = ({ onClose }: Props): JSX.Element => {
  const intl = useIntl();

  return (
    <ModalAlert
      footer={
        // eslint-disable-next-line react/jsx-wrap-multilines
        <FormFooter>
          <FieldRow justify="center" stretched>
            <Button
              look="tertiary"
              palette="muted"
              onClick={onClose}
              data-test-id="modal-close-button">
              {intl.formatMessage({ id: 'users.mailchimp.export.alert.button' })}
            </Button>
          </FieldRow>
        </FormFooter>
      }>
      <SuccessColorful size={40} />
      <Title center indent="sm" data-test-id="mailchimp-success-title">
        {intl.formatMessage({ id: 'users.mailchimp.export.alert.title' })}
      </Title>
      <p data-test-id="mailchimp-success-message">
        {intl.formatMessage({ id: 'users.mailchimp.export.alert.message' })}
      </p>
    </ModalAlert>
  );
};

export default SuccessModal;
